const getMobileOS = () => {
    const userAgent = navigator.userAgent;
    if (/android/i.test(userAgent)) {
        return 'android';
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !globalThis.MSStream) {
        return 'ios';
    }
    return null;
};
export default getMobileOS;
